import { ColumnsSettingsViewDict } from '../typings/common';
import { GdRecommendationStatus } from '../typings/graphql-grid';
import { GridData, SortParams } from '../typings/grid';
import {
    RecommendationKey,
    RecommendationsGridSummaryRecommendation,
    RecommendationType
} from '../typings/recommendations';
import { RecommendationsGridStateClientInfo } from '../typings/state';

export const OPEN_RECOMMENDATIONS_GRID_PAGE = 'OPEN_RECOMMENDATIONS_GRID_PAGE';
export type OPEN_RECOMMENDATIONS_GRID_PAGE = typeof OPEN_RECOMMENDATIONS_GRID_PAGE;

export interface OpenRecommendationsGridPage {
    type: OPEN_RECOMMENDATIONS_GRID_PAGE;
    recommendationType: RecommendationType;
}

export function openRecommendationsGridPage(recommendationType: RecommendationType): OpenRecommendationsGridPage {
    return {
        type: OPEN_RECOMMENDATIONS_GRID_PAGE,
        recommendationType
    };
}

export const FETCH_RECOMMENDATIONS_GRID_SUMMARY = 'FETCH_RECOMMENDATIONS_GRID_SUMMARY';
export type FETCH_RECOMMENDATIONS_GRID_SUMMARY = typeof FETCH_RECOMMENDATIONS_GRID_SUMMARY;

export interface FetchRecommendationsGridSummary {
    type: FETCH_RECOMMENDATIONS_GRID_SUMMARY;
    recommendationType: RecommendationType;
    login: string;
}

export function fetchRecommendationsGridSummary(
    recommendationType: RecommendationType,
    login: string
): FetchRecommendationsGridSummary {
    return {
        type: FETCH_RECOMMENDATIONS_GRID_SUMMARY,
        recommendationType,
        login
    };
}

export const UPDATE_RECOMMENDATIONS_GRID_SUMMARY = 'UPDATE_RECOMMENDATIONS_GRID_SUMMARY';
export type UPDATE_RECOMMENDATIONS_GRID_SUMMARY = typeof UPDATE_RECOMMENDATIONS_GRID_SUMMARY;

export interface UpdateRecommendationsGridSummary {
    type: UPDATE_RECOMMENDATIONS_GRID_SUMMARY;
    summaryRecommendationData?: RecommendationsGridSummaryRecommendation;
}

export function updateRecommendationsGridSummary(
    summaryRecommendationData?: RecommendationsGridSummaryRecommendation
): UpdateRecommendationsGridSummary {
    return {
        type: UPDATE_RECOMMENDATIONS_GRID_SUMMARY,
        summaryRecommendationData
    };
}

export const FETCH_RECOMMENDATIONS_ITEMS = 'FETCH_RECOMMENDATIONS_ITEMS';
export type FETCH_RECOMMENDATIONS_ITEMS = typeof FETCH_RECOMMENDATIONS_ITEMS;

export interface FetchRecommendationsItems {
    type: FETCH_RECOMMENDATIONS_ITEMS;
    index: number;
    recommendationType: RecommendationType;
    login: string;
    sortParams?: SortParams;
}

export function fetchRecommendationsItems(
    recommendationType: RecommendationType,
    login: string,
    index: number,
    sortParams?: SortParams
): FetchRecommendationsItems {
    return {
        type: FETCH_RECOMMENDATIONS_ITEMS,
        recommendationType,
        index,
        login,
        sortParams
    };
}

export const UPDATE_RECOMMENDATIONS_ITEMS = 'UPDATE_RECOMMENDATIONS_ITEMS';
export type UPDATE_RECOMMENDATIONS_ITEMS = typeof UPDATE_RECOMMENDATIONS_ITEMS;

export interface UpdateRecommendationsItems {
    type: UPDATE_RECOMMENDATIONS_ITEMS;
    gridData: GridData;
    clientInfo: RecommendationsGridStateClientInfo;
    recommendationsGridReqId: string;
}

export function updateRecommendationsItems(
    gridData: GridData,
    clientInfo: RecommendationsGridStateClientInfo,
    recommendationsGridReqId: string
): UpdateRecommendationsItems {
    return {
        type: UPDATE_RECOMMENDATIONS_ITEMS,
        gridData,
        clientInfo,
        recommendationsGridReqId
    };
}

export const UPDATE_RECOMMENDATIONS_COLUMNS_WIDTH_DATA = 'UPDATE_RECOMMENDATIONS_COLUMNS_WIDTH_DATA';
export type UPDATE_RECOMMENDATIONS_COLUMNS_WIDTH_DATA = typeof UPDATE_RECOMMENDATIONS_COLUMNS_WIDTH_DATA;

export interface UpdateRecommendationsColumnsWidthData {
    type: UPDATE_RECOMMENDATIONS_COLUMNS_WIDTH_DATA;
    columns: ColumnsSettingsViewDict;
}

export function updateRecommendationsColumnsWidthData(
    columns: ColumnsSettingsViewDict
): UpdateRecommendationsColumnsWidthData {
    return {
        type: UPDATE_RECOMMENDATIONS_COLUMNS_WIDTH_DATA,
        columns
    };
}

export const HANDLE_RECOMMENDATIONS_GRID_COLUMNS_WIDTH_UPDATE = 'HANDLE_RECOMMENDATIONS_GRID_COLUMNS_WIDTH_UPDATE';
export type HANDLE_RECOMMENDATIONS_GRID_COLUMNS_WIDTH_UPDATE = typeof HANDLE_RECOMMENDATIONS_GRID_COLUMNS_WIDTH_UPDATE;

export interface HandleRecommendationsGridColumnsWidthUpdateAction {
    type: HANDLE_RECOMMENDATIONS_GRID_COLUMNS_WIDTH_UPDATE;
    recommendationType: RecommendationType;
    width: number;
    key: string;
}

export function handleRecommendationsGridColumnsWidthUpdate(
    recommendationType: RecommendationType,
    width: number,
    key: string
): HandleRecommendationsGridColumnsWidthUpdateAction {
    return {
        type: HANDLE_RECOMMENDATIONS_GRID_COLUMNS_WIDTH_UPDATE,
        recommendationType,
        width,
        key
    };
}

export const SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM = 'SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM';
export type SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM = typeof SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM;

export interface SubmitRecommendationsGridDataItem {
    type: SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM;
    recommendationType: RecommendationType;
    keys: Array<RecommendationKey>;
    id: string;
    name: string;
}

export function submitRecommendationsGridDataItem(
    recommendationType: RecommendationType,
    keys: Array<RecommendationKey>,
    id: string,
    name: string
): SubmitRecommendationsGridDataItem {
    return {
        type: SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM,
        recommendationType,
        keys,
        id,
        name
    };
}

export const UPDATE_RECOMMENDATIONS_GRID_DATA_ITEM_STATUS = 'UPDATE_RECOMMENDATIONS_GRID_DATA_ITEM_STATUS';
export type UPDATE_RECOMMENDATIONS_GRID_DATA_ITEM_STATUS = typeof UPDATE_RECOMMENDATIONS_GRID_DATA_ITEM_STATUS;

export interface UpdateRecommendationsGridDataItemStatus {
    type: UPDATE_RECOMMENDATIONS_GRID_DATA_ITEM_STATUS;
    id: string;
    status: GdRecommendationStatus;
}

export function updateRecommendationsGridDataItemStatus(
    id: string,
    status: GdRecommendationStatus
): UpdateRecommendationsGridDataItemStatus {
    return {
        type: UPDATE_RECOMMENDATIONS_GRID_DATA_ITEM_STATUS,
        id,
        status
    };
}

export const SUBMIT_RECOMMENDATIONS_GRID_SUMMARY = 'SUBMIT_RECOMMENDATIONS_GRID_SUMMARY';
export type SUBMIT_RECOMMENDATIONS_GRID_SUMMARY = typeof SUBMIT_RECOMMENDATIONS_GRID_SUMMARY;

export interface SubmitRecommendationsGridSummary {
    type: SUBMIT_RECOMMENDATIONS_GRID_SUMMARY;
    recommendationType: RecommendationType;
    keys: Array<RecommendationKey>;
}

export function submitRecommendationsGridSummary(
    recommendationType: RecommendationType,
    keys: Array<RecommendationKey>
): SubmitRecommendationsGridSummary {
    return {
        type: SUBMIT_RECOMMENDATIONS_GRID_SUMMARY,
        recommendationType,
        keys
    };
}

export const UPDATE_RECOMMENDATIONS_GRID_SUMMARY_STATUS = 'UPDATE_RECOMMENDATIONS_GRID_SUMMARY_STATUS';
export type UPDATE_RECOMMENDATIONS_GRID_SUMMARY_STATUS = typeof UPDATE_RECOMMENDATIONS_GRID_SUMMARY_STATUS;

export interface UpdateRecommendationsGridSummaryStatus {
    type: UPDATE_RECOMMENDATIONS_GRID_SUMMARY_STATUS;
    status: GdRecommendationStatus;
}

export function updateRecommendationsGridSummaryStatus(
    status: GdRecommendationStatus
): UpdateRecommendationsGridSummaryStatus {
    return {
        type: UPDATE_RECOMMENDATIONS_GRID_SUMMARY_STATUS,
        status
    };
}

export const GET_RECOMMENDATIONS_GRID_SUMMARY_APPLY_STATUS = 'GET_RECOMMENDATIONS_GRID_SUMMARY_APPLY_STATUS';
export type GET_RECOMMENDATIONS_GRID_SUMMARY_APPLY_STATUS = typeof GET_RECOMMENDATIONS_GRID_SUMMARY_APPLY_STATUS;

export interface GetRecommendationsGridSummaryApplyStatus {
    type: GET_RECOMMENDATIONS_GRID_SUMMARY_APPLY_STATUS;
    recommendationType: RecommendationType;
    requestedKeys: Array<RecommendationKey>;
    enabledForApplyKeys: Array<RecommendationKey>;
}

export function getRecommendationsGridSummaryApplyStatus(
    recommendationType: RecommendationType,
    requestedKeys: Array<RecommendationKey>,
    enabledForApplyKeys: Array<RecommendationKey>
): GetRecommendationsGridSummaryApplyStatus {
    return {
        type: GET_RECOMMENDATIONS_GRID_SUMMARY_APPLY_STATUS,
        recommendationType,
        requestedKeys,
        enabledForApplyKeys
    };
}

export const GET_RECOMMENDATIONS_GRID_ITEM_APPLY_STATUS = 'GET_RECOMMENDATIONS_GRID_ITEM_APPLY_STATUS';
export type GET_RECOMMENDATIONS_GRID_ITEM_APPLY_STATUS = typeof GET_RECOMMENDATIONS_GRID_ITEM_APPLY_STATUS;

export interface GetRecommendationsGridItemApplyStatus {
    type: GET_RECOMMENDATIONS_GRID_ITEM_APPLY_STATUS;
    recommendationType: RecommendationType;
    requestedKey: Array<RecommendationKey>;
    name: string;
}

export function getRecommendationsGridItemApplyStatus(
    recommendationType: RecommendationType,
    requestedKey: Array<RecommendationKey>,
    name: string
): GetRecommendationsGridItemApplyStatus {
    return {
        type: GET_RECOMMENDATIONS_GRID_ITEM_APPLY_STATUS,
        recommendationType,
        requestedKey,
        name
    };
}

export type RecommendationsGridAction =
    | FetchRecommendationsGridSummary
    | UpdateRecommendationsGridSummary
    | UpdateRecommendationsItems
    | UpdateRecommendationsColumnsWidthData
    | FetchRecommendationsItems
    | SubmitRecommendationsGridSummary
    | SubmitRecommendationsGridDataItem
    | UpdateRecommendationsGridSummaryStatus
    | UpdateRecommendationsGridDataItemStatus
    | GetRecommendationsGridSummaryApplyStatus
    | OpenRecommendationsGridPage
    | GetRecommendationsGridItemApplyStatus
    | HandleRecommendationsGridColumnsWidthUpdateAction;
